import React from 'react';

/**
 * Styled text or number input — consistent appearance across all editors.
 *
 * @param {Object}   props
 * @param {string|number} props.value    — Current value
 * @param {Function} props.onChange       — (newValue: string|number) => void
 * @param {string}   [props.type]        — "text" | "number" (default: "text")
 * @param {string}   [props.placeholder] — Placeholder text
 * @param {number}   [props.maxLength]   — Max character length (text only)
 * @param {string}   [props.label]       — Inline label (displayed to the left)
 * @param {string}   [props.labelWidth]  — Tailwind width for label (default: "w-16")
 * @param {string}   [props.className]   — Additional classes for the input
 */
export function TextInput({
  value,
  onChange,
  type = 'text',
  placeholder,
  maxLength,
  label,
  labelWidth = 'w-16',
  className = '',
}) {
  const handleChange = (e) => {
    if (type === 'number') {
      onChange(parseInt(e.target.value, 10) || 0);
    } else {
      onChange(e.target.value);
    }
  };

  const input = (
    <input
      type={type}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      maxLength={type === 'text' ? maxLength : undefined}
      className={`flex-1 bg-white/[0.06] border border-white/10 rounded-lg px-2.5 py-1.5
        text-xs text-white/80 outline-none focus:border-white/25
        placeholder:text-white/25 tabular-nums
        ${type === 'number' ? '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none' : ''}
        ${className}`}
    />
  );

  if (label) {
    return (
      <div className="flex items-center gap-2">
        <span className={`text-[10px] text-white/40 ${labelWidth} shrink-0`}>{label}</span>
        {input}
      </div>
    );
  }

  return input;
}
